import React from 'react'
import { Row, Col } from 'react-bootstrap'
import PerioChart from './PerioChart.component'
import PerioSidePanel from './PerioSidePanel.component'
import {
  PerioChartSectionData,
  PerioSection,
} from '@dataTypes/chartingFeature.types'
import { PerioVoiceHighlight } from '@utils/perio-keyword.utils'
import { GridComponent } from '@syncfusion/ej2-react-grids'

interface PerioMainProps {
  voiceStatus?: React.ReactNode
  voiceActive?: boolean
  chartingInfoFocusTick?: number
  voiceMeasurement?: React.ReactNode
  voiceCursor?: PerioVoiceHighlight
  chartIndex: number
  onViewNote: (id: string) => void
  updatePerioValue: (
    section: PerioSection,
    label: keyof PerioChartSectionData,
    toothIndex: number,
    newValue: string,
  ) => void
  selectedTooth: number
  setSelectedTooth: (tooth: number) => void
  selectedSection: PerioSection
  setSelectedSection: (section: PerioSection) => void
  isFullscreen: boolean
  gridRef: React.RefObject<GridComponent>
  validationErrors: { [key: string]: string }
  setValidationErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string
    }>
  >
}

const PerioMain = ({
  voiceStatus,
  voiceActive = false,
  chartingInfoFocusTick = 0,
  voiceMeasurement,
  voiceCursor,
  chartIndex,
  onViewNote,
  updatePerioValue,
  selectedTooth,
  setSelectedTooth,
  selectedSection,
  setSelectedSection,
  isFullscreen,
  gridRef,
  validationErrors,
  setValidationErrors,
}: PerioMainProps): React.ReactElement => {
  return (
    <Row className="gx-2 perio-row-container">
      <Col>
        <PerioChart
          voiceCursor={voiceCursor}
          chartIndex={chartIndex}
          onViewNote={onViewNote}
          isFullscreen={isFullscreen}
          gridRef={gridRef}
        />
        {isFullscreen && voiceStatus}
      </Col>

      {!isFullscreen && (
        <Col md="auto" className="mh-100">
          <PerioSidePanel
            voiceStatus={voiceStatus}
            voiceActive={voiceActive}
            chartingInfoFocusTick={chartingInfoFocusTick}
            voiceMeasurement={voiceMeasurement}
            selectedTooth={selectedTooth}
            setSelectedTooth={setSelectedTooth}
            selectedSection={selectedSection}
            setSelectedSection={setSelectedSection}
            updatePerioValue={updatePerioValue}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
        </Col>
      )}
    </Row>
  )
}

export default PerioMain
